<script setup>
import { onMounted } from 'vue'
import { useAuthStore } from '@/stores/auth'
import ConfirmModal from '@/components/ConfirmModal.vue'

const auth = useAuthStore()

onMounted(() => {
  auth.fetchMe()
})
</script>

<template>
  <router-view />
  <ConfirmModal />
</template>
  